import {
	apiRequest,
	processInput
} from "@/utilities"

export const facilitatingCourseService = {
	async getFacilitatingCourses() {
		const getFacilitatingCoursesRequest = {
			method: "GET"
		}
		return await apiRequest("/api/facilitating-courses", getFacilitatingCoursesRequest)
	},
	async getFacilitatingCourse(uuid) {
		const getFacilitatingCourseRequest = {
			method: "GET"
		}
		return await apiRequest(`/api/facilitating-courses/${uuid}`, getFacilitatingCourseRequest)
	},
	async createFacilitatingCourse(params) {
		const data = processInput(params)
		const createFacilitatingCourseRequest = {
			method: "POST",
			data
		}
		return await apiRequest("/api/facilitating-courses", createFacilitatingCourseRequest)
	},
	async editFacilitatingCourse(params) {
		const { uuid } = params;
		delete params.uuid;
		let data = processInput(params)
		data.append("_method", "PATCH")
		const editFacilitatingCourseRequest = {
			method: "POST",
			data
		}
		return await apiRequest(`/api/facilitating-courses/${uuid}`, editFacilitatingCourseRequest)
	},
	async deleteFacilitatingCourse(uuid) {
		const deleteFacilitatingCourseRequest = {
			method: "DELETE"
		}
		return await apiRequest(`/api/facilitating-courses/${uuid}`, deleteFacilitatingCourseRequest)
	},
	async reorderFacilitatingCourses(params) {
		const data = processInput(params)
		const reorderFacilitatingCoursesRequest = {
			method: "POST",
			data
		}
		return await apiRequest("/api/facilitating-courses-reorder", reorderFacilitatingCoursesRequest)
	}
}